/* eslint-disable */ 
import React from "react";
import { Link } from "react-router-dom";
import { downloadBrowserCSV } from "../lib/download";
import * as Datetime from "react-datetime";
import Select from "react-select";
import NumberInput from "react-number-input";
import { TextField } from '@material-ui/core';
import _ from 'lodash';
import {
  dateFormat,
  timeFormat,
  setClientDateFormat,
  setClientDateTimeFormat,
  setServerDateFormat
} from "../utility";
import {
  Container,
  Center,
  Bottom,
  Right,
  Area,
  RightGroupList,
  RightGroup,
  RightGroupTable,
  RightGroupTbody,
  RightGroupTableTr,
  RightGroupTableTh,
  RightGroupTableTd,
  FormHeader,
  FormTable,
  FormTd,
  FormTr,
  FormLabel,
  FormInputText,
  FormInputCheck,
  FormTextArea,
  FormIcon,
  BottomDirection,
  Topbar,
  SidebarContainer,
  LeftList,
  LeftListItem,
  LeftListItemSelected,
  Picker
} from "./Base";
import { ReportConfig } from "./ReportConfig";
import Preloader from './Preloader';

const refreshBoard = (props, name) =>
  props.task_request({
    action: "getBoard",
    payload: {
      name
    },
    success: result => {
      result && result.browserdata && result.browserdata.rows && result.browserdata.rows.map(item => {
        item.searchVisible = true
      })
      return props.upsert({
        model: "RX_Page",
        payload: {
          ...result,
          id: 0
        }
      });
    }
  });

class Browser extends React.Component {

  handleSearch = _.debounce((val) => {
    const data = this.props.Session.RX_Page.withId(0).browserdata;
    if (data && data.rows) {
      data.rows.map(x => {
        x.searchVisible = false;
        if (x.name && x.name.toLowerCase().includes(val) || x.definition && x.definition.toLowerCase().includes(val)) {
          x.searchVisible = true;
        }
      })
      this.props.upsert({
        model: 'RX_Page',
        payload: {
          result: {
            browserdata: data.rows,
          },
          id: 0
        }
      })
    }
  }, 500)

  render() {
    const data = this.props.Session.RX_Page.withId(0).browserdata;
    const config = this.props.Session.RX_Page.withId(0).config.browser;

    if (!config) {
      return <div />;
    }
    return (
      <Container
        Rows={"auto 60px"}
        Areas={'"browsercenter" "browserbottom"'}
        style={{ height: "calc(100vh - 40px)" }}
      >
        <Center Area={"browsercenter"}>
          <RightGroupList>
            <RightGroup>
              <TextField onChange={e => this.handleSearch(e.target.value.toLowerCase())} fullWidth label="Filter" style={{ margin: '0 0 15px 0' }} />
              <RightGroupTable>
                <thead>
                  <tr>
                    {config.columns.map((item, index) => (
                      <RightGroupTableTh key={index}>
                        {item.label}
                      </RightGroupTableTh>
                    ))}
                  </tr>
                </thead>
                <RightGroupTbody>
                  {data.rows.map((row, index) => (
                    row.searchVisible && (
                      <RightGroupTableTr
                        Selected={row.id === data.selected}
                        key={index}
                        onClick={() =>
                          this.props.upsert({
                            model: "RX_Page",
                            payload: {
                              id: 0,
                              browserdata: Object.assign({}, data, {
                                selected: row.id
                              })
                            }
                          })
                        }
                      >
                        {config.columns.map((item, index) => (
                          <RightGroupTableTd key={index}>
                            {row[item.field]}
                          </RightGroupTableTd>
                        ))}
                      </RightGroupTableTr>
                    )
                  ))}
                </RightGroupTbody>
              </RightGroupTable>
            </RightGroup>
          </RightGroupList>
        </Center>
        <Bottom Area={"browserbottom"}>
          <div />
          <div>
            <BottomDirection
              className="fa fa-plus"
              title={"New"}
              onClick={e => {
                const config = this.props.Session.RX_Page.withId(0).config.form;
                const empty = {};
                // console.log("config.columns", config.columns);
                // TODO: Default init değerleri koy
                config.columns.map(
                  item =>
                    item.type === "ReportConfig"
                      ? (empty[item.field] = {})
                      : (empty[item.field] = undefined)
                );
                this.props.upsert({
                  model: "RX_Page",
                  payload: {
                    formtype: "New",
                    formdata: Object.assign({}, empty),
                    formcurrent: Object.assign({}, empty),
                    browserdata: Object.assign({}, data, {
                      selected: 0
                    }),
                    id: 0
                  }
                });
              }}
            />
            <BottomDirection
              className="fa fa-pencil"
              title={"Edit"}
              onClick={e => {
                if (!data.selected) {
                  alert("Bu işlemi yapabilmek için lütfen bir kayıt seçiniz!");
                } else {
                  this.props.upsert({
                    model: "RX_Page",
                    payload: {
                      formtype: "Update",
                      id: 0
                    }
                  });
                }
              }}
            />
            <BottomDirection
              className="fa fa-clone"
              title={"Clone"}
              onClick={e => {
                if (!data.selected) {
                  alert("Bu işlemi yapabilmek için lütfen bir kayıt seçiniz!");
                } else {
                  this.props.upsert({
                    model: "RX_Page",
                    payload: {
                      formtype: "Clone",
                      id: 0
                    }
                  })
                };
              }}
            />
            <BottomDirection className="fa fa-eye" title={"View"} />
            <BottomDirection
              className="fa fa-trash"
              title={"Delete"}
              onClick={e => {
                let datum = undefined;
                if (Array.isArray(data.rows)) {
                  datum = data.rows.filter(row => row.id === data.selected)
                  if (datum && datum[0]) {
                    datum = datum[0].name
                  }
                }
                if (!data.selected) {
                  alert("Bu işlemi yapabilmek için lütfen bir kayıt seçiniz!");
                } else if (window.confirm("'" + datum + "' kaydı silinecektir, onaylıyor musunuz?") == true) {
                  return this.props.task_request({
                    action: "browserdelete",
                    payload: {
                      ids: [data.selected]
                    },
                    success: result => {
                      const currentUrl = this.props.match.params.name;
                      const name = this.props.Session.RX_Board.filter({
                        url: currentUrl
                      }).first().name;
                      refreshBoard(this.props, name);
                      return this.props.noop({});
                    }
                  });
                } else {
                  return;
                }
              }}
            />
            <BottomDirection
              className="fa fa-download"
              title={"Download"}
              onClick={e => {
                let headers = config.columns.map(item => item.label);
                downloadBrowserCSV({
                  data: data.rows,
                  headers,
                  filename: "report.csv"
                });
              }}
            />
          </div>
          <div />
        </Bottom>
      </Container>
    );
  }
}

class Sidebar extends React.Component {
  render() {
    // console.log(
    //   "this.props.Session.RX_Board",
    //   this.props.Session.RX_Board.all().toModelArray()
    // );
    const url = this.props.match.params.name;
    return (
      <SidebarContainer>
        <LeftList style={{ flexGrow: 1 }}>
          {this.props.Session.RX_Board.filter(
            item => item.type === "Settings" && item.status === "Active"
          )
            .all()
            .toModelArray()
            .map((item, index) => (
              <Link key={index} to={"/settings/" + item.url}>
                {item.url === url ? (
                  <LeftListItemSelected key={index}>
                    <span
                      style={{ width: "25px" }}
                      className={`fa fa-${item.icon}`}
                    />
                    {item.name}
                  </LeftListItemSelected>
                ) : (
                    <LeftListItem key={index}>
                      <span
                        style={{ width: "25px" }}
                        className={`fa fa-${item.icon}`}
                      />
                      {item.name}
                    </LeftListItem>
                  )}
              </Link>
            ))}
        </LeftList>
        <LeftList>
          <Link to={"/dashboard"}>
            <LeftListItem>
              <span style={{ width: "25px" }} className={`fa fa-cogs`} />
              {"Dashboard"}
            </LeftListItem>
          </Link>
        </LeftList>
      </SidebarContainer>
    );
  }
}

// "New", "Clone", "Update"  şimdilik bunlar var, daha sonra guncellenebilir...
class Form extends React.Component {
  componentWillReceiveProps(nextProps) {
    if (
      !this.props.Session.RX_Page.withId(0) ||
      !this.props.Session.RX_Page.withId(0).browserdata
    )
      return;
    const type = this.props.Session.RX_Page.withId(0).formtype;
    const nextType = nextProps.Session.RX_Page.withId(0).formtype;
    const selected = this.props.Session.RX_Page.withId(0).browserdata.selected;
    const nextSelected = nextProps.Session.RX_Page.withId(0).browserdata
      .selected;
    const formConfig = this.props.Session.RX_Page.withId(0).config.form;

    if (type !== nextType || selected !== nextSelected) {
      const board = this.props.Session.RX_Folder.filter(x => x.id === nextSelected).first();
      const page = this.props.Session.RX_Page.withId(0)
      nextProps.task_request({
        action: "formselect",
        payload: {
          id: nextSelected,
          fullPath: `Settings > ${page ? page.name : '?'} > ${board ? board.name : '?'}`
        },
        success: result => {
          // console.log("formselect success: ", result);
          if (result.formdata)
            formConfig.columns.map((item, index) => {
              switch (item.type) {
                case "SelectQuery":
                case "MultiSelectQuery":
                  if (result.formdata[item.field]) {
                    this.props.task_request({
                      action: "initlist",
                      payload: {
                        field: item.field,
                        values: [result.formdata[item.field]]
                      },
                      success: result => {
                        let columns = formConfig.columns.slice();
                        columns[index].options = result;
                        // console.log("initlist", index, columns[index].options);
                        return this.props.upsert({
                          model: "RX_Page",
                          payload: {
                            id: 0,
                            config: Object.assign(
                              {},
                              this.props.Session.RX_Page.withId(0).config,
                              {
                                form: Object.assign({}, formConfig, {
                                  columns
                                })
                              }
                            )
                          }
                        });
                      }
                    });
                  }
                  break;
                default:
                  break;
              }
              return item;
            });
          return nextProps.upsert({
            model: "RX_Page",
            payload: {
              formdata: Object.assign({}, result.formdata),
              formcurrent: Object.assign({}, result.formdata),
              id: 0
            }
          });
        }
      });
    }
  }
  render() {
    const type = this.props.Session.RX_Page.withId(0).formtype;
    const databaseData = this.props.Session.RX_Page.withId(0).formdata;
    const currentData = this.props.Session.RX_Page.withId(0).formcurrent;
    const formConfig = this.props.Session.RX_Page.withId(0).config.form;
    if (!currentData || !formConfig) return <div />;
    return (
      <Container
        Rows={"40px auto 60px"}
        Areas={'"formtop" "formcenter" "formbottom"'}
        style={{ height: "calc(100vh - 40px)" }}
      >
        <Area Area={"formtop"} style={{ padding: "10px" }}>
          {type === "New" && <FormHeader>{"New Item"}</FormHeader>}
          {type === "Clone" && <FormHeader>{"Clone Item"}</FormHeader>}
          {type === "Update" && (
            <FormHeader>{databaseData[formConfig.header.field]}</FormHeader>
          )}
        </Area>
        <Area
          Area={"formcenter"}
          style={{ padding: "10px", overflowY: "auto" }}
        >
          <FormTable>
            <tbody>
              {formConfig.columns.map((item, index) => (
                <FormTr key={index}>
                  <FormTd>
                    <FormLabel>{item.label}</FormLabel>
                  </FormTd>
                  <FormTd>
                    {item.type === "Text" && (
                      <FormInputText
                        value={
                          currentData[item.field] ? currentData[item.field] : ""
                        }
                        name={item.label}
                        onChange={e =>
                          this.props.upsert({
                            model: "RX_Page",
                            payload: {
                              id: 0,
                              formcurrent: Object.assign({}, currentData, {
                                [item.field]: e.target.value
                              })
                            }
                          })
                        }
                      />
                    )}
                    {item.type === "Bool" && (
                      <FormInputCheck
                        checked={currentData[item.field]}
                        onChange={e => {
                          return this.props.upsert({
                            model: "RX_Page",
                            payload: {
                              id: 0,
                              formcurrent: Object.assign({}, currentData, {
                                [item.field]: e.target.checked
                              })
                            }
                          });
                        }}
                      />
                    )}
                    {item.type === "Currency" && (
                      <NumberInput
                        value={currentData[item.field]}
                        name={item.label}
                        onChange={(value, e) =>
                          this.props.upsert({
                            model: "RX_Page",
                            payload: {
                              id: 0,
                              formcurrent: Object.assign({}, currentData, {
                                [item.field]: value
                              })
                            }
                          })
                        }
                      />
                    )}
                    {item.type === "Textarea" && (
                      <FormTextArea
                        value={
                          currentData[item.field] ? currentData[item.field] : ""
                        }
                        onChange={e =>
                          this.props.upsert({
                            model: "RX_Page",
                            payload: {
                              id: 0,
                              formcurrent: Object.assign({}, currentData, {
                                [item.field]: e.target.value
                              })
                            }
                          })
                        }
                      />
                    )}
                    {item.type === "Date" && (
                      <Datetime
                        utc={true}
                        timeFormat={false}
                        dateFormat={dateFormat}
                        closeOnSelect={true}
                        value={setClientDateFormat(currentData[item.field])}
                        onChange={result =>
                          this.props.upsert({
                            model: "RX_Page",
                            payload: {
                              id: 0,
                              formcurrent: Object.assign({}, currentData, {
                                [item.field]: setServerDateFormat(result) //result.format(dateFormat)
                              })
                            }
                          })
                        }
                      />
                    )}
                    {item.type === "DateTime" && (
                      <Datetime
                        utc={true}
                        timeFormat={timeFormat}
                        dateFormat={dateFormat}
                        closeOnSelect={true}
                        value={setClientDateTimeFormat(currentData[item.field])}
                        onChange={result =>
                          this.props.upsert({
                            model: "RX_Page",
                            payload: {
                              id: 0,
                              formcurrent: Object.assign({}, currentData, {
                                [item.field]: setServerDateFormat(result)
                              })
                            }
                          })
                        }
                      />
                    )}
                    {item.type === "DateInterval" && (
                      <div>
                        <Datetime
                          utc={true}
                          timeFormat={false}
                          dateFormat={dateFormat}
                          closeOnSelect={true}
                          value={setClientDateFormat(
                            currentData[item.field.first]
                          )}
                          isValidDate={first =>
                            currentData[item.field.second]
                              ? first.isSameOrBefore(
                                setClientDateFormat(
                                  currentData[item.field.second]
                                )
                              )
                              : true
                          }
                          onChange={result =>
                            this.props.upsert({
                              model: "RX_Page",
                              payload: {
                                id: 0,
                                formcurrent: Object.assign({}, currentData, {
                                  [item.field.first]: setServerDateFormat(
                                    result
                                  )
                                })
                              }
                            })
                          }
                        />
                        <Datetime
                          utc={true}
                          timeFormat={false}
                          dateFormat={dateFormat}
                          closeOnSelect={true}
                          value={setClientDateFormat(
                            currentData[item.field.second]
                          )}
                          isValidDate={second =>
                            currentData[item.field.first]
                              ? second.isSameOrAfter(
                                setClientDateFormat(
                                  currentData[item.field.first]
                                )
                              )
                              : true
                          }
                          onChange={result =>
                            this.props.upsert({
                              model: "RX_Page",
                              payload: {
                                id: 0,
                                formcurrent: Object.assign({}, currentData, {
                                  [item.field.second]: setServerDateFormat(
                                    result
                                  )
                                })
                              }
                            })
                          }
                        />
                      </div>
                    )}
                    {item.type === "DateTimeInterval" && (
                      <div>
                        <Datetime
                          utc={true}
                          timeFormat={timeFormat}
                          dateFormat={dateFormat}
                          closeOnSelect={true}
                          value={setClientDateTimeFormat(
                            currentData[item.field.first]
                          )}
                          isValidDate={first =>
                            currentData[item.field.second]
                              ? first.isSameOrBefore(
                                currentData[item.field.second]
                              )
                              : true
                          }
                          onChange={result =>
                            this.props.upsert({
                              model: "RX_Page",
                              payload: {
                                id: 0,
                                formcurrent: Object.assign({}, currentData, {
                                  [item.field.first]: setServerDateFormat(
                                    result
                                  )
                                })
                              }
                            })
                          }
                        />
                        <Datetime
                          utc={true}
                          timeFormat={timeFormat}
                          dateFormat={dateFormat}
                          closeOnSelect={true}
                          value={setClientDateTimeFormat(
                            currentData[item.field.second]
                          )}
                          isValidDate={second =>
                            currentData[item.field.first]
                              ? second.isSameOrAfter(
                                currentData[item.field.first]
                              )
                              : true
                          }
                          onChange={result =>
                            this.props.upsert({
                              model: "RX_Page",
                              payload: {
                                id: 0,
                                formcurrent: Object.assign({}, currentData, {
                                  [item.field.second]: setServerDateFormat(
                                    result
                                  )
                                })
                              }
                            })
                          }
                        />
                      </div>
                    )}
                    {item.type === "SelectIcon" && (
                      <Picker
                        Icon={currentData[item.field]}
                        SetIcon={icon =>
                          this.props.upsert({
                            model: "RX_Page",
                            payload: {
                              id: 0,
                              formcurrent: Object.assign({}, currentData, {
                                [item.field]: icon
                              })
                            }
                          })
                        }
                      />
                    )}
                    {(item.type === "SelectQuery" ||
                      item.type === "MultiSelectQuery" ||
                      item.type === "SelectList" ||
                      item.type === "MultiSelectList") && (
                        <Select
                          multi={
                            item.type === "MultiSelectList" ||
                              item.type === "MultiSelectQuery"
                              ? true
                              : false
                          }
                          value={currentData[item.field]}
                          options={item.options}
                          onChange={result => {
                            // console.log("result:", result);
                            this.props.upsert({
                              model: "RX_Page",
                              payload: {
                                id: 0,
                                formcurrent: Object.assign({}, currentData, {
                                  [item.field]: !result
                                    ? undefined
                                    : item.type === "MultiSelectList" ||
                                      item.type === "MultiSelectQuery"
                                      ? result.map(item => item.value)
                                      : result.value
                                })
                              }
                            });
                          }}
                          onOpen={
                            item.type === "SelectList" ||
                              item.type === "MultiSelectList"
                              ? undefined
                              : () => {
                                this.props.task_request({
                                  action: "selectlist",
                                  payload: {
                                    field: item.field,
                                    values: ["%"]
                                  },
                                  success: result => {
                                    let columns = formConfig.columns.slice();
                                    columns[index].options = result;
                                    return this.props.upsert({
                                      model: "RX_Page",
                                      payload: {
                                        id: 0,
                                        config: Object.assign(
                                          {},
                                          this.props.Session.RX_Page.withId(0)
                                            .config,
                                          {
                                            form: Object.assign(
                                              {},
                                              formConfig,
                                              {
                                                columns
                                              }
                                            )
                                          }
                                        )
                                      }
                                    });
                                  }
                                });
                              }
                          }
                          onInputChange={
                            item.type === "SelectList" ||
                              item.type === "MultiSelectList"
                              ? undefined
                              : val => {
                                this.props.task_request({
                                  action: "selectlist",
                                  payload: {
                                    field: item.field,
                                    values: ["%" + val + "%"]
                                  },
                                  success: result => {
                                    console.log(result);
                                    let columns = formConfig.columns.slice();
                                    let options = undefined;
                                    if (Array.isArray(columns[index].options) && Array.isArray(result)) {
                                      // hem result array hem de options array bu durumda merge edeceğiz.
                                      let vals = columns[index].options.map(opt => opt.value);
                                      options = result.filter(res => !vals.includes(res.value));
                                      options = [...columns[index].options, ...options];
                                    } else if (!Array.isArray(result)) {
                                      // result array değil bu durumda eski değerler korunacak
                                      options = columns[index].options;
                                    } else {
                                      // result array ama options array değil
                                      options = result;
                                    }
                                    columns[index].options = options;
                                    return this.props.upsert({
                                      model: "RX_Page",
                                      payload: {
                                        id: 0,
                                        config: Object.assign(
                                          {},
                                          this.props.Session.RX_Page.withId(0)
                                            .config,
                                          {
                                            form: Object.assign(
                                              {},
                                              formConfig,
                                              {
                                                columns
                                              }
                                            )
                                          }
                                        )
                                      }
                                    });
                                  }
                                });
                                return val;
                              }
                          }
                        />
                      )}
                    {item.type === "ReportConfig" && (
                      <ReportConfig
                        {...this.props}
                        value={
                          currentData[item.field] ? currentData[item.field] : ""
                        }
                        databaseValue={
                          databaseData[item.field]
                            ? databaseData[item.field]
                            : ""
                        }
                        name={item.label}
                        onChange={value => {
                          // console.log(value);
                          this.props.upsert({
                            model: "RX_Page",
                            payload: {
                              id: 0,
                              formcurrent: Object.assign({}, currentData, {
                                [item.field]: value
                              })
                            }
                          })
                        }
                          
                        }
                      />
                    )}
                  </FormTd>
                  <FormTd>
                    <FormIcon
                      className="fa fa-undo"
                      onClick={() =>
                        this.props.upsert({
                          model: "RX_Page",
                          payload: {
                            id: 0,
                            formcurrent: Object.assign({}, currentData, {
                              [item.field]: databaseData[item.field]
                            })
                          }
                        })
                      }
                    />
                  </FormTd>
                </FormTr>
              ))}
            </tbody>
          </FormTable>
        </Area>
        <Bottom Area={"formbottom"}>
          <div />
          <div>
            <BottomDirection
              className="fa fa-times"
              title={"Revert"}
              onClick={e => {
                if (window.confirm("Yapılan düzenleme iptal edilecektir, onaylıyor musunuz?") == true) {
                  return this.props.upsert({
                    model: "RX_Page",
                    payload: {
                      id: 0,
                      formcurrent: Object.assign({}, databaseData),
                      formtype: undefined
                    }
                  })
                }
              }
              }
            />
            <BottomDirection
              className="fa fa-floppy-o"
              title={"Save"}
              onClick={e => {
                if (window.confirm("Yapılan düzenleme kaydedilecektir, onaylıyor musunuz?") == true) {
                  // console.log("Saveing", currentData);
                  let task = undefined;
                  const type = this.props.Session.RX_Page.withId(0).formtype;
                  // TODO: iki durum var, ilki: iki field olan kısımların kaydı..
                  // ikincisi: multiselect query değerleri...
                  if (
                    type === "Clone" ||
                    currentData.id === undefined ||
                    currentData.id === null
                  ) {
                    task = {
                      action: "forminsert",
                      payload: {
                        values: currentData
                        // values: formConfig.columns.map( (item, index) => currentData[item.field] )
                      }
                    };
                  } else {
                    task = {
                      action: "formupdate",
                      payload: {
                        values: currentData
                        // values: [
                        //   currentData.id,
                        //   ...formConfig.columns.map(
                        //     (item, index) => currentData[item.field]
                        //   )
                        // ]
                      }
                    };
                  }
                  return this.props.task_request({
                    ...task,
                    success: result => {
                      // console.log("form save success", result);
                      // return this.props.noop({});
                      const currentUrl = this.props.match.params.name;
                      if (
                        this.props.Session.RX_Board.filter({
                          url: currentUrl
                        }).exists()
                      ) {
                        const name = this.props.Session.RX_Board.filter({
                          url: currentUrl
                        }).first().name;
                        refreshBoard(this.props, name);
                      }
                      // console.log("form before upsert", result);
                      return this.props.upsert({
                        model: "RX_Page",
                        payload: {
                          id: 0,
                          formtype: undefined
                        }
                      });
                      // return this.props.upsert({
                      //   model: "RX_Page",
                      //   payload: {
                      //     formdata: Object.assign(
                      //       {},
                      //       currentData,
                      //       result.formdata
                      //     ),
                      //     id: 0
                      //   }
                      // });
                    }
                  });
                }
              }}
            />
          </div>
          <div />
        </Bottom>
      </Container>
    );
  }
}

export class FormBrowser extends React.Component {
  constructor(props) {
    super(props);
    const url = props.match.params.name;
    if (props.Session.RX_Board.filter({ url }).exists()) {
      const name = props.Session.RX_Board.filter({ url }).first().name;
      refreshBoard(props, name);
    }
  }
  componentWillReceiveProps(nextprops) {
    const oldUrl = this.props.match.params.name;
    const url = nextprops.match.params.name;
    if (oldUrl !== url && nextprops.Session.RX_Board.filter({ url }).exists()) {
      const name = nextprops.Session.RX_Board.filter({ url }).first().name;
      refreshBoard(nextprops, name);
    }
  }
  render() {
    if (!this.props.Session.RX_Page.hasId(0)) {
      return <Preloader />;
    }
    const formtype = this.props.Session.RX_Page.withId(0).formtype;
    return (
      <Container
        Rows={"40px auto"}
        Columns={formtype ? "200px auto 500px" : "200px auto 0"}
        Areas={'"top top top" "left center right"'}
      >
        <Topbar {...this.props} Area={"top"} />
        <Sidebar Area={"left"} {...this.props} />
        <Center Area={"center"} style={{ position: "relative" }}>
          <Browser {...this.props} />
        </Center>
        <Right Area={"right"}>
          <Form {...this.props} />
        </Right>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FormBrowser.js